import { Component, OnInit } from '@angular/core';
import { EventService } from '@app/event/event.service';
import { Router } from '@angular/router';
import { SpeechService } from '@app/event/speech-engines/speech.service';
import { RoutingService } from '@app/routing.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import {
  CurrentUserGQL,
  EventGQL,
  EventQuery,
  EventQueryVariables,
  UpdateEventGQL
} from '@app/graphql/generated';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { ModalService } from '@app/shared/modal/modal.service';
import { Apollo, QueryRef } from 'apollo-angular';
import { UserService } from '@app/user/user.service';
import { MatDialogRef } from '@angular/material/dialog';
import gql from 'graphql-tag';
import { EventZoomLinkService, ZoomLink } from '@app/services/event-zoom-link.service';
import { translateLanguages } from '@app/translateLanguages';
import { BehaviorSubject, Observable } from 'rxjs';

interface ViewModel {
  form: FormGroup;
}

@Component({
  selector: 'app-edit-event',
  templateUrl: './edit-event.component.html',
  styleUrls: ['./edit-event.component.scss']
})
export class EditEventComponent implements OnInit {
  viewModel: ViewModel;
  zoomLinkStatuses = [{label: 'Enabled', value: true},{label: 'Disabled', value: false}];
  languages = translateLanguages.map(l => ({ label: l.name, value: l.code }));
  rowsEditing = {};
  public event;

  private eventQueryRef: QueryRef<EventQuery, EventQueryVariables>;
  linkDropdownOptions = this.currentUserGQL.fetch().pipe(
    filter(res => !res.loading),
    map(res =>
      res.data.currentUser.links.map(link => ({
        label: link.link,
        value: link.link
      }))
    )
  );

  encoderDropdownOptions = this.userService.currentUser().pipe(
    filter(res => !res.loading),
    map(user =>
      user.encoders.map(encoder => ({
        label: `${encoder.type} - ${encoder.ip}:${encoder.port}`,
        value: encoder.uuid
      }))
    )
  );
  purgeOptions: any = [{ label: 'Never', value: 'never' }, { label: 'Daily', value: 'daily' }, {
    label: 'Weekly',
    value: 'weekly'
  }];

 public outputs = new FormGroup({encoders: new FormArray([])});

 linksToAdd = new BehaviorSubject<ZoomLink[] & {isNew?: boolean}>([]);
 zoomLinks = new BehaviorSubject<ZoomLink[] & {isNew?: boolean}>([]);

 getZoomLinks() {
   this.eventZoomLink.getZoomLinks(this.routingService.eventId).pipe(
     switchMap(links => this.linksToAdd.pipe(
        map((newLinks) => {
           return [...newLinks, ...links, ].map(link => ( {...link, uniqueId: Symbol()} ));
        }
        )
     )),
   ).subscribe(this.zoomLinks);
 }

  constructor(
    private matDialogRef: MatDialogRef<EditEventComponent>,
    private eventService: EventService,
    private router: Router,
    private speechService: SpeechService,
    private routingService: RoutingService,
    private currentUserGQL: CurrentUserGQL,
    public modalService: ModalService,
    private updateEventGQL: UpdateEventGQL,
    private userService: UserService,
    private eventGQL: EventGQL,
    private eventZoomLink: EventZoomLinkService,
    private apollo: Apollo) {
    matDialogRef.updateSize('400');

  }

  ngOnInit() {
   this.getZoomLinks();
    this.viewModel = {
      form: new FormGroup({
        title: new FormControl('test'),
        useZoomCaptions: new FormControl(false),
        zoomAPIKey: new FormControl(),
        visibility: new FormControl('public'),
        link: new FormControl('auto'),
        purgeFrequency: new FormControl('never'),
        uppercase: new FormControl()
        // encoder: new FormControl()
      })
    };

    this.eventQueryRef = this.eventGQL.watch({
      input: { shortId: this.routingService.eventId }
    });

    this.eventQueryRef.valueChanges
      .pipe(filter(res => !res.loading))
      .subscribe(res => {
        this.event = res.data.event;
        this.viewModel.form.patchValue({ ...res.data.event });
        ;
      });
  }

  submit() {
    this.updateEventGQL
      .mutate({
        input: {
          ...this.viewModel.form.value,
          purgeFrequency: this.viewModel.form.value.purgeFrequency === 'never' ? null : this.viewModel.form.value.purgeFrequency,
          shortId: this.routingService.eventId
        }
      })
      .subscribe(() => {
        this.modalService.close();
        this.eventQueryRef.refetch();
      });

  }

  purgeEvent() {

  }

  deleteEvent() {
    const mutation = gql`mutation deleteEvent($input: String!){
    deleteEvent(input: $input)
    }
    `;

    this.apollo.mutate({ mutation, variables: { input: this.routingService.eventId } }).subscribe(() => {
      this.router.navigate(['/events'])
    });
  }

  onRowEditInit(product: any) {

  }

  onRowEditSave(product: any) {
   if(product.isNew) {
  this.eventZoomLink.createZoomLink(this.routingService.eventId, product).subscribe(() => {
    this.linksToAdd.next(this.linksToAdd.value.filter(l => l.id !== product.id));
    this.getZoomLinks();
  });
   } else {
     this.eventZoomLink.updateZoomLink(product).subscribe(() => {
       this.getZoomLinks();
     });
   }
  }

  onRowEditCancel(product: any, ri: any) {

  }

  add(dt) {
   const nextId = (this.zoomLinks.value.sort((a,b) => b.id - a.id)[0]?.id + 1) || 1;
    this.linksToAdd.next([{ id: nextId, isNew: true, zoomApiLink: '', enabled: true, outputLanguage: 'en' }, ...this.linksToAdd.value, ])
    this.rowsEditing[nextId] = true;
  }

  deleteEncoder(zoomLink: any) {
    const res = confirm('Are you sure you want to delete this zoom link?');
    if(res) {
      this.eventZoomLink.deleteZoomLink(zoomLink.id).subscribe(() => {
        this.getZoomLinks();
      });
    }}
}
